import LegalEntityModel from "./LegalEntityModel";

export default class LegalEntityBranchModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.name = data.name ?? '';
			this.description = data.description;
			this.address = data.address ?? '';
			this.workingHours = data.workingHours;

			if (data.legalEntity?.id) {
				this.legalEntity = new LegalEntityModel(data.legalEntity);
			}
		}
	}

	id = 0;
	name = '';
	description: string | null = null;
	address = '';
	workingHours: string | null = null;
	hourlySalary = 0;
	legalEntity: LegalEntityModel | null = null;
}